<script setup lang="ts">
import Button from '~/components/design-system/button.vue';
import { useAuthStore } from '~/stores/auth.store';
import { CheckCircleIcon } from '@heroicons/vue/24/outline';
import { useSiteStore } from '~/stores/site.store';

const { $t } = useNuxtApp();
const auth = useAuthStore();
const site = useSiteStore();
const { $marketingService } = useServices();

function depositNow() {
  site.deactivateModal();
  auth.toggleAccountModal(true);
  auth.setAccountModalPage('deposit');
}

function depositLater() {
  site.deactivateModal();
}

onUnmounted(() => {
  if (site.getFeatureFlags.get('website.toastmessages'))
    $marketingService.fetchToasts();
});
</script>

<template>
  <div class="flex flex-col flex-wrap justify-center align-content-start mx-3">
    <div class="flex justify-center mt-3 w-full">
      <CheckCircleIcon class="text-primary-blue-700 w-16 h-16" />
    </div>
    <p class="font-bold text-base text-base-color mb-3">
      {{ $t('success-complete-profile') }}
    </p>
    <p class="text-base text-base-color mb-3">
      <strong>{{ $t('id-verification') }}:&nbsp;</strong>
      <span class="text-primary-blue-500">
        {{ $t('successful') }}
      </span>
    </p>
  </div>
  <div class="w-full dark:bg-dark-800 bg-light-200 flex justify-center">
    <Button class="w-full m-3 justify-center" @click="depositNow()">
      {{ $t('deposit-now') }}
    </Button>
    <Button
      element-name="deposit-later"
      class="w-full m-3 justify-center"
      type="secondary"
      @click="depositLater()"
    >
      {{ $t('deposit-later') }}
    </Button>
  </div>
</template>
